import createIcon from '@/lib/create-icon'

const FutsalIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      fill='none'
      d='M23 5.75C13.4731 5.75 5.75 13.4731 5.75 23C5.75 32.5269 13.4731 40.25 23 40.25C32.5269 40.25 40.25 32.5269 40.25 23C40.25 13.4731 32.5269 5.75 23 5.75ZM23 5.75C20.9923 5.75 19.0647 6.09298 17.2727 6.72356L22.9998 10.5417M23 5.75C25.0076 5.75 26.9351 6.09296 28.7271 6.72349L22.9998 10.5417M22.9998 10.5417V17.25M22.9998 17.25L17.2498 21.0833M22.9998 17.25L28.7498 21.0833M12.4582 18.2083L17.2498 21.0833M12.4582 18.2083L5.77702 22.0263C6.00395 17.9478 7.64769 14.2475 10.2242 11.4093L10.5417 11.5L12.4582 18.2083ZM17.2498 21.0833L19.1665 28.75M33.5415 18.2083L28.7498 21.0833M28.7498 21.0833L26.8332 28.75M19.1665 28.75L17.2498 33.5417M19.1665 28.75H26.8332M17.2498 33.5417L20.1248 39.2917L19.838 39.9608C15.8344 39.2192 12.316 37.0949 9.79676 34.1018L10.1655 33.5417L17.2498 33.5417ZM26.8332 28.75L28.7498 33.5417M28.7498 33.5417H35.8343L36.2352 34.0637C33.6748 37.1234 30.0733 39.2819 25.9754 39.9943L25.875 39.2917L28.7498 33.5417ZM35.5501 11.1653C38.28 14.0592 40.02 17.8971 40.2288 22.1376L39.8005 22.0417L33.0923 18.2083L35.0088 11.5L35.5501 11.1653Z'
      stroke='url(#paint0_linear_5314_351)'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M23 5.75C13.4731 5.75 5.75 13.4731 5.75 23C5.75 32.5269 13.4731 40.25 23 40.25C32.5269 40.25 40.25 32.5269 40.25 23C40.25 13.4731 32.5269 5.75 23 5.75ZM23 5.75C20.9923 5.75 19.0647 6.09298 17.2727 6.72356L22.9998 10.5417M23 5.75C25.0076 5.75 26.9351 6.09296 28.7271 6.72349L22.9998 10.5417M22.9998 10.5417V17.25M22.9998 17.25L17.2498 21.0833M22.9998 17.25L28.7498 21.0833M12.4582 18.2083L17.2498 21.0833M12.4582 18.2083L5.77702 22.0263C6.00395 17.9478 7.64769 14.2475 10.2242 11.4093L10.5417 11.5L12.4582 18.2083ZM17.2498 21.0833L19.1665 28.75M33.5415 18.2083L28.7498 21.0833M28.7498 21.0833L26.8332 28.75M19.1665 28.75L17.2498 33.5417M19.1665 28.75H26.8332M17.2498 33.5417L20.1248 39.2917L19.838 39.9608C15.8344 39.2192 12.316 37.0949 9.79676 34.1018L10.1655 33.5417L17.2498 33.5417ZM26.8332 28.75L28.7498 33.5417M28.7498 33.5417H35.8343L36.2352 34.0637C33.6748 37.1234 30.0733 39.2819 25.9754 39.9943L25.875 39.2917L28.7498 33.5417ZM35.5501 11.1653C38.28 14.0592 40.02 17.8971 40.2288 22.1376L39.8005 22.0417L33.0923 18.2083L35.0088 11.5L35.5501 11.1653Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M23 5.75C13.4731 5.75 5.75 13.4731 5.75 23C5.75 32.5269 13.4731 40.25 23 40.25C32.5269 40.25 40.25 32.5269 40.25 23C40.25 13.4731 32.5269 5.75 23 5.75ZM23 5.75C20.9923 5.75 19.0647 6.09298 17.2727 6.72356L22.9998 10.5417M23 5.75C25.0076 5.75 26.9351 6.09296 28.7271 6.72349L22.9998 10.5417M22.9998 10.5417V17.25M22.9998 17.25L17.2498 21.0833M22.9998 17.25L28.7498 21.0833M12.4582 18.2083L17.2498 21.0833M12.4582 18.2083L5.77702 22.0263C6.00395 17.9478 7.64769 14.2475 10.2242 11.4093L10.5417 11.5L12.4582 18.2083ZM17.2498 21.0833L19.1665 28.75M33.5415 18.2083L28.7498 21.0833M28.7498 21.0833L26.8332 28.75M19.1665 28.75L17.2498 33.5417M19.1665 28.75H26.8332M17.2498 33.5417L20.1248 39.2917L19.838 39.9608C15.8344 39.2192 12.316 37.0949 9.79676 34.1018L10.1655 33.5417L17.2498 33.5417ZM26.8332 28.75L28.7498 33.5417M28.7498 33.5417H35.8343L36.2352 34.0637C33.6748 37.1234 30.0733 39.2819 25.9754 39.9943L25.875 39.2917L28.7498 33.5417ZM35.5501 11.1653C38.28 14.0592 40.02 17.8971 40.2288 22.1376L39.8005 22.0417L33.0923 18.2083L35.0088 11.5L35.5501 11.1653Z'
      stroke='url(#paint1_radial_5314_351)'
      strokeOpacity='0.6'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5314_351'
        x1='5.75'
        y1='5.75'
        x2='45.1888'
        y2='33.1381'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5314_351'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 40.25) scale(17.25 17.5687)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'FutsalIcon'
)

export default FutsalIcon
